export const getEnergyType = (type) => {
    type = Number(type)
    let text = ''
    switch (type) {
        case 1:
            text = '纯电'
            break
        case 2:
            text = '插电混动'
            break
        case 3:
            text = '燃油'
            break
        case 4:
            text = '油电混动'
            break
        case 5:
            text = '增程式'
            break
        default: 
            text = ''
            break
    }
    return text
}
const add0 = (m) => {
    return m < 10 ? "0" + m : m;
};
export const timestampToString = (date_str) => {
    date_str = date_str.replace(/-/g, "/");
    let shijianchuo = new Date(date_str) * 1;
    let time = new Date(shijianchuo);
    let y = time.getFullYear();
    let m = time.getMonth() + 1;
    let d = time.getDate();
    return y + "年" + add0(m) + "月" + add0(d) + "日";
};
